import {
	JsonClassSerializer,
	JsonClassSerializerOptions,
} from '@sumbricht/json-class-serializer'
export {
	JsonClassSerializer,
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonSetProperty,
	jsonMapProperty,
	AnyType,
} from '@sumbricht/json-class-serializer'
import { commonJsonMapperOptions } from './json-mapper-const.js'

export * from './json-mapper-const.js'

JsonClassSerializer.defaultOptions = {
	...JsonClassSerializer.defaultOptions,
	...commonJsonMapperOptions,
}
JsonClassSerializer.defaultInstance.options = JsonClassSerializer.defaultOptions
export const jsonMapper = new JsonClassSerializer(commonJsonMapperOptions)
export const allowPlainRootJsonMapper = new JsonClassSerializer({
	...commonJsonMapperOptions,
	failIfRootClassNotFound: false,
})
export const allowPlainObjectJsonMapper = new JsonClassSerializer({
	...commonJsonMapperOptions,
	failIfRootClassNotFound: false,
	failIfTypeResolutionFails: false,
})
export const prettyPrintJsonMapper = new JsonClassSerializer({
	...commonJsonMapperOptions,
	prettyPrint: true,
})
